import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from "vue";
import SvgProfile from "@/assets/svg/profile.svg";
import SafeImage from "@/components/shared/SafeImage.vue";
import { capitalize } from "@/helpers/filters";
import { Image } from "@/types/models";


export default /*#__PURE__*/_defineComponent({
  __name: 'GenericAvatar',
  props: {
    avatar: { default: null },
    variant: { default: undefined },
    label: { default: undefined },
    size: { default: "md" }
  },
  setup(__props: any) {

const props = __props as { avatar: Image | null, variant: "cut-out", label: string, size: "sm" | "md" | "lg" | "xl" };



const failedFetchingImage = ref(false);

const fallbackLabel = computed(() => {
  if (!props.label) {
    return;
  }

  // We estimate initials:
  // First initial: first letter capitalized
  // Second initial: last capital letter following space
  //    or last letter following space, capitalized
  //    or nothing

  const label = capitalize(props.label);
  let firstLetter = label[0];

  let capitalLettersFollowingSpace = [...label.matchAll(/\s+([\p{Lu}\p{Lt}])/gu)];
  if (capitalLettersFollowingSpace.length > 0) {
    return firstLetter + capitalLettersFollowingSpace[capitalLettersFollowingSpace.length - 1][1];
  }

  let lettersFollowingSpace = [...label.matchAll(/\s+(\w)/gu)];

  if (lettersFollowingSpace.length > 0) {
    return firstLetter + lettersFollowingSpace[lettersFollowingSpace.length - 1][1];
  }

  return firstLetter;
});

return { __sfc: true,props, failedFetchingImage, fallbackLabel, SvgProfile, SafeImage }
}

})